const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiClient = async (method, url, getToken, data = {}) => {
  const token = await getToken();
  const options = {
    method,
    headers: new Headers({
      Authorization: `Bearer ${token}`,
      'Content-type': 'application/json',
    }),
    body: JSON.stringify(data),
  };

  if (method === 'GET') {
    delete options.body;
  }

  const response = await fetch(`${BASE_URL}${url}`, options);
  let json;
  try {
    json = await response.json();
  } catch {
    json = null;
  }

  if (response.status >= 500) {
    throw new Error(json?.message || `Request failed with status ${response.status}`);
  }

  return json;
};

export { apiClient };
